'use strict';

var React = require('react');

var SvgLayoutSidebarLeftIcon = function SvgLayoutSidebarLeftIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.25 16.5a1.75 1.75 0 0 1-1.75-1.75v-9.5c0-.966.784-1.75 1.75-1.75h1.5c.966 0 1.75.784 1.75 1.75v9.5a1.75 1.75 0 0 1-1.75 1.75h-1.5Zm-.25-1.75c0 .138.112.25.25.25h1.5a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25h-1.5a.25.25 0 0 0-.25.25v9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 16.5a1.75 1.75 0 0 1-1.75-1.75v-.5a.75.75 0 0 1 1.5 0v.5c0 .138.112.25.25.25h.5a.75.75 0 0 1 0 1.5h-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.75 16.5a1.75 1.75 0 0 0 1.75-1.75v-.5a.75.75 0 0 0-1.5 0v.5a.25.25 0 0 1-.25.25h-.5a.75.75 0 0 0 0 1.5h.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5.25c0-.966.784-1.75 1.75-1.75h.5a.75.75 0 0 1 0 1.5h-.5a.25.25 0 0 0-.25.25v.5a.75.75 0 0 1-1.5 0v-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 5.25a1.75 1.75 0 0 0-1.75-1.75h-.5a.75.75 0 0 0 0 1.5h.5a.25.25 0 0 1 .25.25v.5a.75.75 0 0 0 1.5 0v-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 8.25a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9a.75.75 0 0 0-1.5 0v2a.75.75 0 0 0 1.5 0v-2Z"
  }));
};
SvgLayoutSidebarLeftIcon.displayName = "LayoutSidebarLeftIcon";

exports.SvgLayoutSidebarLeftIcon = SvgLayoutSidebarLeftIcon;
